export const INIT_BUSINESS_DATA = 'INIT_BUSINESS_DATA'
export const ADD_TO_CART = 'ADD_TO_CART'
export const SET_DISCOUNT_MODAL = 'SET_DISCOUNT_MODAL'
export const SET_LOADING = 'SET_LOADING'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_BUSINESSES = 'SET_BUSINESSES'
export const COPY_BILLING_ADDRESS_FROM_DEFAULT = 'COPY_BILLING_ADDRESS_FROM_DEFAULT'
export const SET_BUSINESS_SID = 'SET_BUSINESS_SID'
export const ADD_NEW_USER_TO_LIST = 'ADD_NEW_USER_TO_LIST'
export const SET_NEW_USER_ID = 'SET_NEW_USER_ID'
export const ADD_MANUFACTURER = 'ADD_MANUFACTURER'
export const REMOVE_MANUFACTURER = 'REMOVE_MANUFACTURER'
export const UPDATE_MANUFACTURER_PERCENT = 'UPDATE_MANUFACTURER_PERCENT'
export const SET_DISTRIBUTORS = 'SET_DISTRIBUTORS'
export const SET_SALES_REPS = 'SET_SALES_REPS'
export const ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT'
export const REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_INFO = 'SET_INFO'
export const SET_USERS = 'SET_USERS'
export const SET_BILLING = 'SET_BILLING'
export const SET_DISCOUNTS = 'SET_DISCOUNTS'
export const SET_NOTES = 'SET_NOTES'
export const ADD_NOTE_TO_LIST = 'ADD_NOTE_TO_LIST'
export const RESET_PERIOD_DATA = 'RESET_PERIOD_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/business/types.js